function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTenders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.711,
    height: 37.5,
    viewBox: "0 0 46.711 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9639"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9637",
    style: {
      opacity: 0.67
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9675",
    d: "M355.763 1638.053 377.868 1662l22.105-23.948-9.21-11.052h-25.789z",
    transform: "translate(-354.513 -1625.75)",
    style: {
      fill: "none",
      stroke: "#687c97",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px",
      strokeDasharray: "4 4 4 4 4 4"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTenders);
export default __webpack_public_path__ + "static/media/no-tenders.60b1c9f2.svg";
export { ForwardRef as ReactComponent };